<template>
  <div class="pt-3 h-full overflow-hidden flex flex-col">
    <div class="flex flex-wrap gap-x-5 mb-2 items-center">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
        class="!w-56"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-radio-group v-model="state.params.pickup_type" @change="onLoad()">
        <el-radio-button
          v-for="item in [
            { Text: '全部' },
            ...$base.Meeting_Pickup_Car_Type?.filter((w) =>
              [1, 2].includes(w.Key),
            ),
          ]"
          :key="item.Key"
          :value="item.Key"
          >{{ item.Text }}
        </el-radio-button>
      </el-radio-group>
      <el-button type="primary" @click="onLoad">查询</el-button>
      <li class="flex-1">
        <el-button
          type="info"
          link
          icon="Refresh"
          @click="onReset()"
          style="margin-left: -10px"
        >
          重置
        </el-button>
      </li>
      <el-button type="primary" link @click="onExport" icon="Download">
        导出
      </el-button>
    </div>
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      :default-sort="{
        prop: state.params.sort_field,
        order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
      }"
      ref="tableDom"
      @sort-change="onSortChange"
    >
      <el-table-column
        fixed
        label="#"
        width="70"
        type="index"
        :index="
          (index) =>
            $buildTabIndex(state.params.page, state.params.limit, index)
        "
        align="center"
      />
      <el-table-column prop="name" label="姓名" :formatter="$tab_TextFormat" />
      <el-table-column
        prop="phone"
        label="联系电话"
        :formatter="$tab_TextFormat"
      />
      <el-table-column label="类型">
        <template #default="{ row }">
          <c_status
            arrName="Meeting_Pickup_Car_Type"
            :value="row.pickup_type"
            :key="row.pickup_type"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="transport_no"
        label="航班/车次"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        prop="departure_time"
        label="出发时间"
        sortable="departure_time"
        :formatter="$tab_TextFormat"
        :width="160"
      >
        <template #default="{ row }">
          <text>{{ $dayjs(row.departure_time).format("YYYY-MM-DD HH:mm") }}</text>
        </template>
      </el-table-column>
      <el-table-column
        prop="departure_name"
        label="出发地点"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        prop="arrival_time"
        label="到达时间"
        sortable="arrival_time"
        :formatter="$tab_TextFormat"
        :width="160"
      >
        <template #default="{ row }">
          <text>{{ $dayjs(row.arrival_time).format("YYYY-MM-DD HH:mm") }}</text>
        </template>
      </el-table-column>
      <el-table-column
        prop="arrival_name"
        label="到达地点"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        prop="meetingCar.driver_name"
        label="接送司机"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        prop="meetingCar.number"
        label="车牌号"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        prop="meetingCar.driver_phone"
        label="司机电话"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        prop="pickup_intro"
        label="接送备注"
        :formatter="$tab_TextFormat"
      />
      <el-table-column label="操作" fixed="right" align="center" :width="140">
        <template #default="{ row }">
          <el-button
            type="primary"
            :icon="Select"
            link
            @click.stop="
              state.selectId = row.id;
              state.showCheck = true;
            "
            v-if="!row.meeting_car_id"
            >派车
          </el-button>
          <el-button
            type="danger"
            :icon="Close"
            link
            @click.stop="onCancel(row)"
            v-else
            >取消派车
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.page"
      :pageSize="state.params.limit"
      @onLoad="
        (page) => {
          state.params.page = page.pageIndex;
          state.params.limit = page.pageSize;
          onLoad();
        }
      "
    />
  </div>
  <el-dialog
    v-model="state.showCheck"
    title="派车"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showCheck = false;
      }
    "
    width="70%"
  >
    <c_check
      :id="state.selectId"
      :meeting_id="props.meeting_id"
      @close="
        state.showCheck = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_service_transport_pickup_page,
  meeting_service_transport_pickup_export,
  meeting_service_transport_pickup_cancelArrange,
} from "@/http/meetingservice";
import { funcExport, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_check from "./Check.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_check,
  },
  props: {
    meeting_id: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      state.params.keywords = props.params?.keywords;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meeting_service_transport_pickup_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    const onReset = () => {
      state.params = {
        meeting_id: props.meeting_id,
      };
    };

    //导出
    const onExport = () => {
      let data = {
        ...state.params,
      };
      data.page = 1;
      data.limit = 0;

      funcExport(meeting_service_transport_pickup_export, data);
    };

    const onCancel = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-danger);">取消派车</strong>吗？`,
        "取消派车",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_service_transport_pickup_cancelArrange({
          id: row.id,
        }).then((res) => {
          post_response(res, onLoad);
        });
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    return { state, props, onLoad, onExport, onReset, onCancel, onSortChange };
  },
};
</script>

<style lang="less" scoped></style>
